import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';

interface ViewOnlyBlockModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ViewOnlyBlockModal({
  open,
  onOpenChange,
}: ViewOnlyBlockModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <div className="text-center py-2">
          <div className="mx-auto w-14 h-14 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-4">
            <Eye className="h-7 w-7 text-gray-600 dark:text-gray-400" />
          </div>

          <h2 className="text-xl font-semibold mb-2">View-Only Access</h2>

          <p className="text-muted-foreground text-sm mb-6">
            Your account has view-only access to this business. View-only users can see documents but cannot send them. Contact an admin if you need send permissions.
          </p>

          <Button
            className="w-full h-12"
            onClick={() => onOpenChange(false)}
          >
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
